/**
 * A utility method that grabs the desired fields from the URL parameters and
 * returns an object with the available fields.
 * @param {Array[String]} field URL Parameters to extract
 * @returns {Object} Object containing found parameters
 */
function extractFieldsFromURLParams(fields) {
  const url = new URL(window.location);
  const searchParams = new URLSearchParams(url.search);
  const payload = {};
  fields.forEach((parameter) => {
    const value = searchParams.get(parameter);
    if (value) payload[parameter] = value;
  });
  return payload;
}

/**
 * Get the email and name fields from url parameters.
 */
export function getEmailAndName() {
  return extractFieldsFromURLParams(["email", "name"]);
}

export default extractFieldsFromURLParams;
